import MuiTextField from '@mui/material/TextField';

import makeController from './makeController';

MuiTextField.displayName = 'MuiTextField';
const TextField = makeController(MuiTextField);
TextField.displayName = 'TextField';

export default TextField;
